module.exports = __webpack_public_path__ + "static/media/12.a80c013d.svg";